import { XSection } from '@adornis/chemistry/elements/components/x-section.js';
import { customElement } from 'lit/decorators.js';

/**
 * @element tr-section
 */
@customElement('tr-section')
export class TrSection extends XSection {}
